import React from 'react';

const renderFieldSelected = ({ input, habilitar,label,option,meta: { touched, error } }) => (
  <div className="form-group">
      <label className="control-label">{label}</label>
      <select
                {...input} 
                disabled   = { habilitar ? true : false }
                className="form-control">
                <option value="">Selecione...</option>
                {option}
               
      </select>
      {touched && error && <span className="text-danger">{error}</span>}
  
  </div>
);

export default renderFieldSelected;





// WEBPACK FOOTER //
// ./src/container/renderFieldSelect.js